import { INavigationMenu } from 'components/Layout/Header/Navigation'
import { Link } from 'gatsby'
import React, { useState } from 'react'
import { Collapse } from 'react-collapse'

interface Props {
	menu: INavigationMenu
}

export default function MobileMenuItem({ menu }: Props) {
	const [open, setOpen] = useState(true)

	return (
		<>
			{menu.href ? (
				<Link to={menu.href} className={`gap-1 px-4 py-4 text-center text-white hover:text-white hover:no-underline ${menu.colors.mobileBg}`}>
					<span className="block text-2xl font-normal">{menu.name}</span>
				</Link>
			) : (
				<button className={`gap-1 px-4 py-4 text-white ${menu.colors.mobileBg}`} onClick={() => setOpen(!open)}>
					<span className="block text-2xl font-normal">{menu.name}</span>
				</button>
			)}

			<Collapse
				isOpened={open}
				theme={{
					collapse: `ReactCollapse--collapse transition-all duration-200 ease-in-out`,
					content: `ReactCollapse--content ${menu.colors.mobileBgLight}`
				}}
			>
				{menu.menuItems &&
					menu.menuItems.map((item) => {
						return item.href ? (
							<Link key={item.name} to={item.href} className="flex items-center rounded-lg px-6 py-4 hover:no-underline">
								<div className="relative">
									{item.isNew && (
										<div className="absolute top-[2px] -right-10 bg-red-500 text-white rounded px-1 text-xs">
											<span>New</span>
										</div>
									)}
									<p className={`mb-0 font-medium tracking-wide ${menu.colors.mobileText}`}>{item.name}</p>
								</div>
							</Link>
						) : (
							<a
								key={item.name}
								href={item.externalLink}
								target="_blank"
								rel="noopener noreferrer"
								className="flex items-center rounded-lg px-6 py-4 hover:no-underline"
							>
								<div className="relative">
									{item.isNew && (
										<div className="absolute top-[2px] -right-10 bg-red-500 text-white rounded px-1 text-xs">
											<span>New</span>
										</div>
									)}
									<p className={`mb-0 font-medium tracking-wide ${menu.colors.mobileText}`}>{item.name}</p>
								</div>
							</a>
						)
					})}
			</Collapse>
		</>
	)
}
